<script lang="ts" setup>
  import { useMouseInElement } from '@vueuse/core';
  import { ElLink } from 'element-plus';
  import { computed, ref, watchEffect } from 'vue';
  import { customLinkType, darkenColor, getLinkIcon, linkEmits, LinkProps } from './link';

  defineOptions({
    name: 'ILink',
  });
  const props = defineProps(LinkProps);
  const emit = defineEmits(linkEmits);

  const handleClick = (evt: MouseEvent) => {
    if (!props.disabled) emit('click', evt);
  };

  const _icon = computed(() => getLinkIcon(props.type, props.icon));
  const _color = computed(() => {
    return props.color
      ? props.color
      : props.type && customLinkType[props.type]
        ? customLinkType[props.type].color || 'var(--el-color-primary)'
        : 'var(--el-color-primary)';
  });

  const linkRef = ref();
  const { isOutside } = useMouseInElement(linkRef);
  const changeColorByIsOutside = () => {
    if (props.disabled) return;
    if (isOutside.value) {
      if (linkRef.value) {
        (linkRef.value?.$el as HTMLDivElement).style.color = _color.value;
      }
    } else {
      const color = (linkRef.value?.$el as HTMLDivElement).style.color;
      (linkRef.value?.$el as HTMLDivElement).style.color =
        color.indexOf('var') > -1 ? 'var(--el-color-primary-dark-2)' : props.hover || darkenColor(color, 0.2);
    }
  };
  watchEffect(() => changeColorByIsOutside());
</script>

<template>
  <ElLink ref="linkRef" class="t-link" :underline="false" :disabled="disabled" @click="handleClick">
    <div v-if="$slots.icon || _icon" class="t-link-icon">
      <slot v-if="$slots.icon" name="icon" />
      <i v-else class="iconfont" :class="[_icon]" />
    </div>
    <div class="t-link-content">
      <slot name="default" />
    </div>
  </ElLink>
</template>
